import { ApiType } from "./ApiType";
import { appCheckHeader } from "../appCheck";

const SendOtp = async (payload) => {
  const headers = await appCheckHeader();
  const data = await ApiType.postRequest(
    "/api/auth/login-with-mobile-number",
    payload,
    headers
  );
  return data;
};

const ResendOtp = async (payload) => {
  const headers = await appCheckHeader();
  const data = await ApiType.postRequest("/api/auth/resend-otp", payload, headers);
  return data;
};

const Login = async (payload) => {
  const data = await ApiType.postRequest("/api/auth/verified-otp", payload);
  return data;
};

const GetUser = async (payload = "") => {
  const data = await ApiType.getRequest(`/api/auth/getUserByID/${payload?.id}`, "");
  return data;
};

const GetBoard = async (payload = "") => {
  const data = await ApiType.getRequest(`/api/board/mobile`, payload);
  return data;
};

const GetMediam = async (payload = "") => {
  const data = await ApiType.getRequest(`/api/medium/mobile`, payload);
  return data;
};

const GetStandard = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/standard/mobile/get-list-by-notice`,
    payload
  );
  return data;
};

const GetSemester = async (payload = "") => {
  const data = await ApiType.getRequest(`/api/semester/mobile`, payload);
  return data;
};

const GetSubject = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/subject/mobile/subject-list`,
    payload
  );
  return data;
};

const GetAutoStandard = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/bluprint-paper/getstandard`,
    payload
  );
  return data;
};

const GetAutoSemester = async (payload = "") => {
  const data = await ApiType.getRequest(`/api/bluprint-paper/getSemester`, payload);
  return data;
};

const GetAutoSubject = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/bluprint-paper/getSubject`,
    payload
  );
  return data;
};

const GetNotice = async (body) => {
  const data = await ApiType.postRequest(`/api/notice/mobile`, body);
  return data;
};

const GetDraft = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/paper-generation-save-draft`,
    payload
  );
  return data;
};

const CreateDraft = async (body) => {
  const data = await ApiType.postRequest(
    `/api/paper-generation-save-draft/create`,
    body
  );
  return data;
};

const GetQtype = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/paper-generation/mobile/qtypes-with-chapters`,
    payload
  );
  return data;
};

const GetQuestion = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/paper-generation/question`,
    payload
  );
  return data;
};

const GetInstituteimages = async (payload = "") => {
  const data = await ApiType.getRequest(`/api/instituteimages`, payload);
  return data;
};

const ImageUpload = async (body) => {
  const data = await ApiType.axiospostRequest(`/api/upload/single_file`, body);
  return data;
};

const Createinstituteimages = async (body) => {
  const data = await ApiType.postRequest(`/api/instituteimages/create`, body);
  return data;
};

const RemoveImage = async (id) => {
  const data = await ApiType.DeleteRequest(`/api/instituteimages/${id}`);
  return data;
};

const paperHistory = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/paper-generation/mobile`,
    payload
  );
  return data;
};

const htmlToBase64 = async (html) => {
  const data = await ApiType.customRequest(
    `/api/html-to-base64`,
    "POST",
    null,
    html
  );
};

const GetMarks = async (body) => {
  const data = await ApiType.postRequest(
    `/api/paper-generation/get-auto-papernew-marks`,
    body
  );
  return data;
};

const GetMarksData = async (body) => {
  const data = await ApiType.getRequest(
    `/api/bluprint-paper/getMarks${body}`,

  );
  return data;
};

const GetChapter = async (payload = "") => {
  const data = await ApiType.getRequest(`/api/chapter/mobile`, payload);
  return data;
};

const GenerateAutoPaper = async (body) => {
  const data = await ApiType.postRequest(
    `/api/paper-generation/create-auto-paperNew`,
    body
  );
  return data;
};

const GenerateAutoPaperWithBluePrint = async (body) => {
  const data = await ApiType.postRequest(`/api/paper-generation/create-blue-print-paper`, body);
  return data;
}

const GetNotices = async (payload) => {
  const data = await ApiType.postRequest(`/api/random_generate_notice/mobile`, payload);
  return data;
}

const GetRandomQuestionList = async (payload) => {
  const data = await ApiType.postRequest(`/api/paper-generation/get-random-question-list`, payload);
  return data;
}

const GetPriceForSpecificSubject = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/subscriptionPrice/getPriceForSpecificSubject`,
    payload
  );
  return data;
};

const GetPromocode = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/promocode/getByName/${payload.promocode}`,
    payload
  );
  return data;
};

const CreateSubscription = async (body) => {
  const data = await ApiType.postRequest(`/api/subscription/create`, body);
  return data;
};

const PaymentSuccess = async (body) => {
  const data = await ApiType.postRequest(
    `/api/subscription/paymentSuccess`,
    body
  );
  return data;
};

const UpdateProfile = async (body) => {
  const data = await ApiType.putRequest(
    `/api/user/update/${body.id}`,
    body?.data
  )
  return data;
}

const PaperGetById = async (id = "") => {
  const data = await ApiType.getRequest(`/api/paper-generation/mobile/Paper/${id}`);
  return data;
}

const deletePaper = async (id) => {
  const data = await ApiType.DeleteRequest(`/api/paper-generation/mobile/deletePaper/${id}`);
  return data;
};

const uplodedImage = async (payload) => {
  const data = await ApiType.postRequest(`/api/upload/single_file`, payload);
  return data;
}

const getSubjectPurchase = async (payload = "") => {
  const data = await ApiType.getRequest(`/api/subscription/getSubscriptionHistoryOfUser`, payload);
  return data;
}

const getQuestionsReport = async (payload = "") => {
  const data = await ApiType.getRequest(`/api/questionsReport/getbyUser`, payload);
  return data;
}

const getQuestionsReportById = async (payload = "", id) => {
  const data = await ApiType.getRequest(`/api/questionsReport/getbyUser/${id}`, payload);
  return data;
}

const QuestionsReport = async (body) => {
  const data = await ApiType.postRequest(`/api/questionsReport/create`, body);
  return data;
}

const CreatePaper = async (body) => {
  const data = await ApiType.postRequest(`/api/paper-generation/mobile/generate-paper-manually`, body);
  return data;
}

const UpdatePaper = async (body) => {
  const data = await ApiType.putRequest(
    `/api/paper-generation/mobile/updatePaper/${body.id}`,
    body?.data
  )
  return data;
}

const ConvertLaxTaXIntoMathMl = async (body) => {
  const data = await ApiType.postRequest(
    `/api/paper-generation/mobile/convertLaxTaXIntoMathMl`,
    JSON.stringify(body)
  );
  return data;
};

const GetSampleStandard = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/sample-paper/getStandard`,
    payload
  );
  return data;
};

const GetSampleSemester = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/sample-paper/getSemester`,
    payload
  );
  return data;
};

const GetSampleSubject = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/sample-paper/getSubject`,
    payload
  );
  return data;
};

const GetSamplePapers = async (payload = "") => {
  const data = await ApiType.getRequest(
    `/api/sample-paper/mobile`,
    payload
  );
  return data;
};

export const Api = {
  SendOtp,
  ResendOtp,
  Login,
  GetUser,
  GetBoard,
  GetMediam,
  GetStandard,
  GetSemester,
  GetSubject,
  GetAutoStandard,
  GetAutoSemester,
  GetAutoSubject,
  GetNotice,
  GetDraft,
  CreateDraft,
  GetQtype,
  GetQuestion,
  GetInstituteimages,
  ImageUpload,
  Createinstituteimages,
  RemoveImage,
  paperHistory,
  htmlToBase64,
  GetMarks,
  GetMarksData,
  GetChapter,
  GenerateAutoPaper,
  GenerateAutoPaperWithBluePrint,
  GetNotices,
  GetRandomQuestionList,
  PaymentSuccess,
  CreateSubscription,
  GetPromocode,
  GetPriceForSpecificSubject,
  UpdateProfile,
  PaperGetById,
  deletePaper,
  uplodedImage,
  getSubjectPurchase,
  getQuestionsReport,
  QuestionsReport,
  getQuestionsReportById,
  CreatePaper,
  UpdatePaper,
  ConvertLaxTaXIntoMathMl,
  GetSampleStandard,
  GetSampleSemester,
  GetSampleSubject,
  GetSamplePapers,
};
